import React, { useState } from "react";
import "./Research.css";
import Footer from "../Homepage/Footer/Footer";
import Navbar from "../Homepage/Navbar/Navbar";
import ThrustAreas from "./ThrustAreas";

const tabs = [
  "About",
  "Research Area",
  "PATENTS DETAILS",
  "RESEARCH CENTERS",
  "MAJOR EQUIPMENT",
  "PROPOSED ACTIVITIES",
  "RESEARCH STUDENTS",
  "PH.D. REGULATIONS",
  "PROJECTS",
];

const Research = () => {
  const [activeTab, setActiveTab] = useState("About");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <Navbar />

      <div className="research-page">
        {/* Banner */}
        <div className="research-banner">
          <img src="/campuslife/sciencelab/slab-10.JPG" alt="Research" />
          <h2>Research & Development</h2>
        </div>

        {/* Mobile Toggle */}
        <button
          className="research-mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          ☰ Research Navigation
        </button>

        <div className="research-layout">
          {/* ================= SIDEBAR ================= */}
          <aside className={`research-sidebar ${mobileOpen ? "open" : ""}`}>
            <div className="research-sidebar-header">
              <h3>Research Sections</h3>
            </div>

            <nav className="research-sidebar-nav">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`research-nav-item ${activeTab === tab ? "active" : ""
                    }`}
                  onClick={() => {
                    setActiveTab(tab);
                    setMobileOpen(false);
                  }}
                >
                  {tab}
                </button>
              ))}
            </nav>
          </aside>

          {/* ================= CONTENT ================= */}
          <main className="research-content">
            {/* ABOUT */}
            {activeTab === "About" && (
              <>
                {/* Leadership Section */}
                <div className="research-leadership">

                  {/* Director Card */}
                  <div className="research-card">
                    <div className="research-image">
                      <img src="/businessmanagement/prof vishwanath reddy.png" alt="Dr. C. Viswanatha Reddy" />
                    </div>
                    <div className="research-info">
                      <h3>Dr. C. Viswanatha Reddy</h3>
                      <p className="designation">Director of Research Studies</p>
                      <p>
                        <a href="mailto:vsrits@gmail.com">vsrits@gmail.com</a>
                      </p>
                      <p>
                        <a href="mailto:directorresearch.ru@gmail.com">
                          directorresearch.ru@gmail.com
                        </a>
                      </p>
                      <p>📞 9848263463</p>
                    </div>
                  </div>

                  {/* Coordinator Card */}
                  <div className="research-card">
                    <div className="research-image">
                      <img src="/statistics/Ragu.JPG" alt="Dr. Y. Raghunatha Reddy" />
                    </div>
                    <div className="research-info">
                      <h3>Dr. Y. Raghunatha Reddy</h3>
                      <p className="designation">Coordinator of Research Studies</p>
                      <p>
                        <a href="mailto:drraghuy@gmail.com">drraghuy@gmail.com</a>
                      </p>
                      <p>
                        <a href="mailto:researchevaluation.ru@gmail.com">
                          researchevaluation.ru@gmail.com
                        </a>
                      </p>
                      <p>📞 8985858282</p>
                    </div>
                  </div>

                </div>

                {/* About Research Section */}
                <div className="about-research-full">
                  <h3>About Research at Rayalaseema University</h3>
                  <p>
                    Rayalaseema University is committed to fostering a strong research culture
                    that promotes innovation, interdisciplinary collaboration, and societal
                    impact. The University encourages fundamental, applied, and translational
                    research across Science, Engineering, Humanities, Social Sciences, and
                    Management.
                  </p>
                  <p>
                    The University provides a conducive research ecosystem supported by modern
                    laboratories, advanced research equipment, digital library resources, and
                    dedicated research centers. Faculty members and research scholars actively
                    engage in sponsored research projects, consultancy services, and
                    collaborative programs funded by UGC, DST, SERB, ICSSR, and other national
                    and international agencies.
                  </p>
                </div>

              </>
            )}

            {activeTab === "Research Area" && <ThrustAreas />}

            {activeTab !== "About" &&
              activeTab !== "Research Area" && (
                <h3 style={{ textAlign: "center", marginTop: "40px" }}>
                  Content will be updated soon
                </h3>
              )}
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Research;
